module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0024.jpg?v=c3794c2a";